<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/Oracle/Accounts">Oracle</b-breadcrumb-item>
            <b-breadcrumb-item active>Accounts</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Oracle Accounts</div>
            <div class="card-body">
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row">
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Account Name</label>
                                <input
                                        class="form-control"
                                        placeholder="Account Username"
                                        v-model="filterOptions.userName"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Person Name</label>
                                <input
                                        class="form-control"
                                        placeholder="Person Name"
                                        v-model="filterOptions.personName"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group">
                                <label>Module Access</label>
                                <select class="form-control" v-model="filterOptions.moduleId">
                                    <option :value="null">-- Filter By Module Access --</option>
                                    <option :key="module.id" :value="module.id" v-for="module in moduleList">
                                        {{module.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-4 col-sm-6 form-group">
                                <AppCheckBox
                                        v-model="filterOptions.onlyShowActiveAccounts"
                                >Only Show Active Accounts
                                </AppCheckBox>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>

                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="accounts"
                        :responsive="true"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                        <router-link
                                :to="{name:'OracleAccountDetails',params:{id:row.item.id,accountName:row.item.userName}}"
                                class="btn btn-sm btn-warning d-print-none"
                                data-toggle="tooltip"
                                title="Edit account details">
                            <i class="fa fa-pencil-alt"></i>Edit
                        </router-link>
                    </template>

                    <template v-slot:cell(expirationDate)="row">
                        <span>{{row.item.expirationDate | moment('MM/DD/YYYY')}}</span>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalAccounts"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>

            </div>
        </div>

    </div>
</template>

<script>
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import {ToastType} from "@/services/models/shared/ToastType";
    import OracleService from "../../services/OracleService";
    import AppCheckBox from "../../components/shared/AppCheckBox";

    export default {
        components: {
            AppFormCardCollapsable,
            AppTablePagination,
            AppCheckBox
        },
        data() {
            return {
                isPerformingAction: false,
                accounts: [],
                totalAccounts: 0,
                moduleList: [],
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    personName: null,
                    userName: null,
                    onlyShowActiveAccounts: false,
                    moduleId: null
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:150px'
                    },
                    {
                        key: 'userName',
                        label: 'Username',
                    },
                    {
                        key: 'personName',
                        label: 'Person Name',
                    },
                    {
                        key: 'employeeStatus',
                        label: 'Person Status',
                    },
                    {
                        key: 'accountStatus',
                        label: 'Account Status',
                    },
                    {
                        key: 'expirationDate',
                        label: 'Expiry Date',
                    },
                ]
            }
        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                OracleService.getOracleAccountList(vm.filterOptions)
                    .then(response => {
                        vm.accounts = response.data;
                        vm.totalAccounts = response.totalCount;
                    }).catch(error => {
                    vm.alert(ToastType.Danger, error.response.statusText)
                }).finally(() => {
                    vm.isLoading = false;
                });

                // We can load these modules after page load
                OracleService.getAllModules()
                    .then(response => {
                        vm.moduleList = response;
                    })
            },

            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
